
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("biDFC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cf7e1688a1791eb7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $cf7e1688a1791eb7$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Team \u2022 Over 50 medlemmer",
    'fabric.elements.mentions.team.member.50plus.including.you': "Team \u2022 Over 50 medlemmer, inklusive dig",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Team \u2022 1 medlem} other {Team \u2022 {0} medlemmer}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Team \u2022 1 medlem, inklusive dig} other {Team \u2022 {0} medlemmer, inklusive dig}}",
    'fabric.elements.mentions.xproduct.mention.description': 'Har brug for adgang til Confluence',
    'fabric.mention.error.defaultAction': "Pr\xf8v igen om nogle sekunder",
    'fabric.mention.error.defaultHeadline': 'Noget gik galt',
    'fabric.mention.error.differentText': "Pr\xf8v at indtaste en anden tekst",
    'fabric.mention.error.loginAgain': "Pr\xf8v at logge ud og derefter ind igen",
    'fabric.mention.noAccess.label': 'Ingen adgang',
    'fabric.mention.noAccess.warning': "{name} f\xe5r ikke besked, da personen ikke har adgang",
    'fabric.mention.unknow.user.error': 'Ukendt bruger {userId}'
};

});


//# sourceMappingURL=da.a6e51006.js.map
